import { CoreTagsName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getTags } from '@api';
import { updateTagReferences } from './_idMap/actions';

export const coreTagsGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [ (response) => updateTagReferences(response) ]
	},
	name: CoreTagsName,
	receive: true,
	request: false,
	requestHandler: () =>
		getTags().then((response) => ({
			...response,
			data: response.data ? response.data.sort((a, b) => a.name.localeCompare(b.name)) : undefined
		})),
	retainDataOnRequest: true
});
